/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';

/**
 * 
 * @export
 * @interface SwitchSubscriptionRequestDto
 */
export interface SwitchSubscriptionRequestDto {
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof SwitchSubscriptionRequestDto
     */
    lookupKey: LookupKeyEnum | null;
}

export function SwitchSubscriptionRequestDtoFromJSON(json: any): SwitchSubscriptionRequestDto {
    return SwitchSubscriptionRequestDtoFromJSONTyped(json, false);
}

export function SwitchSubscriptionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchSubscriptionRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lookupKey': LookupKeyEnumFromJSON(json['lookupKey']),
    };
}

export function SwitchSubscriptionRequestDtoToJSON(value?: SwitchSubscriptionRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lookupKey': LookupKeyEnumToJSON(value.lookupKey),
    };
}

